import axios from 'axios';

import { HTTPRequestException } from '@/exceptions/HTTPRequestException';
import { HTTPResponseException } from '@/exceptions/HTTPResponseException';
import { NetworkError } from '@/exceptions/NetworkError';
import { UserModule } from '@/store/modules/user';

export const BASE_API = process.env.VUE_APP_BASE_API || 'https://design.sjtu.daguchuangyi.com/api';

const service = axios.create({
  baseURL: BASE_API,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
});

service.interceptors.request.use(
  (config) => {
    config.params = {
      ...config.params,
      lang: 'zh_cn',
    };
    if (UserModule.token) {
      config.headers.Authorization = UserModule.token;
    }
    return config;
  },
  (error) => Promise.reject(new HTTPRequestException(error)),
);

/**
 * 在此处始终抛出异常，便于调用者 catch
 * 最终未被 catch 的异常在 errorHandler 中处理
 */
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      return Promise.reject(new NetworkError(error));
    }
    return Promise.reject(new HTTPResponseException(error));
  },
);

export default service;
